<div *ngIf="editable; else previewMode">
  <div
    *ngIf="errorMessage"
    role="alert"
    class="mb-4 rounded-xl border border-red-200 bg-red-50 p-3 text-sm font-medium text-red-700"
  >
    {{ errorMessage }}
  </div>

  <div
    *ngIf="successMessage"
    class="mb-4 rounded-xl border border-emerald-200 bg-emerald-50 p-3 text-sm font-medium text-emerald-700"
  >
    {{ successMessage }}
  </div>

  <!-- Header -->
  <div class="mb-8 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
    <div>
      <h2 class="text-2xl font-semibold text-[#1E2A78]">
        {{ 'CREDIT_RECOMMENDATIONS.TITLE' | translate }}
      </h2>

      <p class="mt-1 text-sm text-gray-500">
        {{ 'CREDIT_RECOMMENDATIONS.SUBTITLE' | translate }}
      </p>
    </div>

    <div class="flex flex-wrap gap-3">
      <button
        type="button"
        (click)="addParagraph()"
        class="section-add-btn"
      >
        {{ 'CREDIT_RECOMMENDATIONS.ADD_PARAGRAPH' | translate }}
      </button>
    </div>
  </div>

  <!-- Title -->
  <div class="mb-6 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
    <label class="mb-2 block text-sm font-medium text-gray-700">
      {{ 'CREDIT_RECOMMENDATIONS.SECTION_TITLE' | translate }}
    </label>

    <input
      [(ngModel)]="sectionTitle"
      type="text"
      [placeholder]="'CREDIT_RECOMMENDATIONS.SECTION_TITLE_PLACEHOLDER' | translate"
      class="h-12 w-full rounded-xl border border-gray-300 px-4 outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100"
    />
  </div>

  <!-- Empty state -->
  <div
    *ngIf="paragraphs.length === 0"
    class="rounded-2xl border border-indigo-100 bg-gradient-to-r from-indigo-50 to-blue-50 p-10 text-center"
  >
    <h3 class="text-lg font-semibold text-[#1E2A78]">
      {{ 'CREDIT_RECOMMENDATIONS.NO_PARAGRAPH_TITLE' | translate }}
    </h3>

    <p class="mt-2 text-gray-500">
      {{ 'CREDIT_RECOMMENDATIONS.NO_PARAGRAPH_HINT' | translate }}
    </p>
  </div>

  <!-- Paragraph Blocks -->
  <div class="space-y-5" cdkDropList (cdkDropListDropped)="onParagraphDrop($event)">
    <div
      *ngFor="let paragraph of paragraphs; let i = index; trackBy: trackByIndex"
      cdkDrag
      cdkDragLockAxis="y"
      class="section-drag-item overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm"
    >
      <div class="flex items-center justify-between border-b bg-gray-50 px-5 py-4">
        <div class="flex items-center gap-4">
          <app-section-drag-handle cdkDragHandle></app-section-drag-handle>

          <div
            class="flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-100 font-semibold text-[#1E2A78]"
          >
            {{ i + 1 }}
          </div>

          <div>
            <h3 class="font-semibold text-gray-800">
              {{ 'CREDIT_RECOMMENDATIONS.PARAGRAPH_N' | translate: { n: i + 1 } }}
            </h3>

            <p class="text-xs text-gray-500">
              {{ 'CREDIT_RECOMMENDATIONS.NARRATIVE' | translate }}
            </p>
          </div>
        </div>

        <button
          type="button"
          (click)="requestRemoveParagraph(i)"
          class="section-delete-btn"
        >
          {{ 'COMMON.DELETE' | translate }}
        </button>
      </div>

      <div class="p-6">
        <label class="mb-2 block text-sm font-medium text-gray-700">
          {{ 'CREDIT_RECOMMENDATIONS.PARAGRAPH_CONTENT' | translate }}
        </label>

        <app-rich-text-editor
          [(ngModel)]="paragraphs[i]"
          minHeight="160px"
          [placeholder]="'CREDIT_RECOMMENDATIONS.PARAGRAPH_PLACEHOLDER' | translate"
        ></app-rich-text-editor>
      </div>
    </div>
  </div>

  <app-popup
    [(show)]="showDeletePopup"
    title="CREDIT_RECOMMENDATIONS.DELETE_PARAGRAPH"
    type="confirm"
    [message]="deleteMessage"
    confirmText="COMMON.DELETE"
    cancelText="COMMON.CANCEL"
    (confirmed)="confirmRemoveParagraph()"
  ></app-popup>
</div>

<!-- PREVIEW MODE -->
<ng-template #previewMode>
  <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
    <h2 class="mb-5 text-xl font-semibold text-[#1E2A78]">
      {{ sectionTitle || ('CREDIT_RECOMMENDATIONS.RECOMMENDATIONS' | translate) }}:
    </h2>

    <div *ngIf="activeParagraphs.length > 0; else noPreviewData" class="space-y-6">
      <div
        *ngFor="let paragraph of activeParagraphs; let i = index; trackBy: trackByIndex"
        class="rich-text-content leading-8 text-gray-700"
        [innerHTML]="paragraph | richText"
      ></div>
    </div>

    <ng-template #noPreviewData>
      <div class="rounded-xl border border-dashed border-gray-300 bg-gray-50 p-8 text-center text-gray-500">
        {{ 'CREDIT_RECOMMENDATIONS.NO_RECOMMENDATIONS' | translate }}
      </div>
    </ng-template>
  </div>
</ng-template>